export const SUBMIT_CART= 'SUBMIT_CART'
export const SUBMIT_CART_SUCCESS= 'SUBMIT_CART_SUCCESS'
export const SUBMIT_CART_ERROR='SUBMIT_CART_ERROR'

export const SubmitCart= (data) => ({
    type: SUBMIT_CART,
    payload: data
})